import { Button } from 'shared/ui'
import { LINK_CAMPAIGNS_HELP_GUIDE } from 'shared/constants/links'

type ICampaignsHelpGuideButtonProps = {
  className?: string
}

export const CampaignsHelpGuideButton = ({ className }: ICampaignsHelpGuideButtonProps) => (
  <Button
    tag='a'
    text='Help guide'
    size='medium'
    contained='secondary'
    href={LINK_CAMPAIGNS_HELP_GUIDE}
    target='_blank'
    rel='noreferrer'
    style={{ textDecoration: 'none' }}
    className={className}
    iconProps={{ icon: 'info' }}
  />
)
